import { PATHS } from '@constants/paths'

export const ROUTES_WITHOUT_HEADER = [
    PATHS.APPOINTMENT_SCHEDULER,
    'firstTimeUser',
]
